export const iconFontAwesomeDesignRulerCombined = (
	<i className="fa-solid fa-ruler-combined"></i>
);
